import { Metro, STATE_PER_METRO } from '../../../components/SearchHeader/constants';
import { OpaqueUrl } from '../../../routing/util';
import { safeKeysOf } from '../../../util/safeKeysOf';
import { Container, Inner, LinkContainer, StyledLink, Title } from './LocationLinks.styles';

export interface Props {
  title: string;
  searchUrlHandler: (metro?: Metro) => OpaqueUrl;
  linkContainerText: (metro: Metro) => string;
}

export const LocationLinks = ({ title, searchUrlHandler, linkContainerText }: Props) => (
  <Container>
    <Inner>
      <Title h5>{title}</Title>
      <LinkContainer>
        {safeKeysOf(STATE_PER_METRO).map((metro, index) => (
          <StyledLink key={index} to={searchUrlHandler(metro)}>
            {linkContainerText(metro)}
          </StyledLink>
        ))}
      </LinkContainer>
    </Inner>
  </Container>
);
